module.exports = __webpack_public_path__ + "media/svg/eh-f5ee0a5e.svg";